/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest = {
  ledgerCanisterId: string;
};

/** @internal */
export const GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$inboundSchema:
  z.ZodType<
    GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$Outbound =
  {
    ledger_canister_id: string;
  };

/** @internal */
export const GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$outboundSchema:
  z.ZodType<
    GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$Outbound,
    z.ZodTypeDef,
    GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$ {
  /** @deprecated use `GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$inboundSchema;
  /** @deprecated use `GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$outboundSchema;
  /** @deprecated use `GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$Outbound` instead. */
  export type Outbound =
    GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$Outbound;
}

export function getLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequestToJSON(
  getLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest:
    GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest,
): string {
  return JSON.stringify(
    GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$outboundSchema
      .parse(getLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest),
  );
}

export function getLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetLedgerImageApiV1ImagesLedgersLedgerCanisterIdPngGetRequest' from JSON`,
  );
}
